import React from 'react'
import SidebarMenu from '../../componets/Home/MenuSidebar/sidebarMenu'
import BreadCrumb from '../../componets/Home/BreadCrumb'
import { Link } from 'react-router-dom'
import NuevoTipoActividadFuncionarios from '../../componets/Home/NuevosDashboards/NuevoTipoActividadFuncionario/NuevoTipoActividadFuncionarios'
import '../../assets/css/Sidebar.css'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const TipoActividadFuncionario = () => {

    const home = (
        <Link className="breadcrubsLink" to="/registroActividades/inicio">Inicio</Link>
    )

    const consultar = (
        <span className="disabled">Detalles de tipos de actividad Funcionario Proveedor</span>
    )

    if (!cookies.get('code')) {
        window.location.href = "/singOff"
    }

    const menu = JSON.parse(sessionStorage.getItem("permissions"))
    const permisos = menu.rol

    if (permisos[28].permisos[2] === "") {
        window.location.href = "/registroActividades/inicio"
    }

    return (
        <div>
            <SidebarMenu
                accesoProp={permisos}
                noShowProp={true}
            />
            <div className="content">
                <BreadCrumb
                    home={home}
                    consultar={consultar}

                />
                <div className="container">

                    <h1 className="tittle">Detalles de tipos de actividad Funcionario Proveedor</h1>


                </div>
                <div className="tabla">
                    <NuevoTipoActividadFuncionarios />
                </div>
            </div>
        </div>
    )
}

export default TipoActividadFuncionario